import React from "react";

const WhatIsCreditActivity = (props: any) => {
    return (
        <p>
            Any credit file activity identified by TransUnion. Categories include personal information, account summary, inquiries, revolving & installment accounts
            and public records.
        </p>
    );
};

export default WhatIsCreditActivity;
